// extracted by mini-css-extract-plugin
export default {"lightbox":"y8Qmfn","label":"CsCcPJ","info":"UVDZ8b mz-default-dark-font","question":"oVEZqc mz-default-dark-font","buttons":"SZivfv","button":"TTLs3W"};